export const prePrincipleColor = "text-blue-500";
export const preInterestColor = "text-orange-500";
export const preLateColor = "text-red-500";
export const prePaidColor = "text-purple-500"
export const preOverflow = "text-green-600"
export const prePaidAllColor = "text-yellow-600"
export const prePaidRemainAfterColor = "text-purple-500"
export const feeRemarkColor = "text-gray-600"

export const columnSticky = "sticky left-0 top-0 bg-white z-50"
